export default {
  en: {
    fillOnboarding: 'Fill onboarding',
  },
  ru: {
    fillOnboarding: 'Заполнить онбординг',
  },
  de: {
    fillOnboarding: 'Onboarding ausfüllen',
  },
  pt: {
    fillOnboarding: 'Preencher onboarding',
  },
  fr: {
    fillOnboarding: 'Remplir l’onboarding',
  },
  es: {
    fillOnboarding: 'Rellenar el onboarding',
  },
};
